module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/banner/zh-hant-90ea4d817d953c6f807fc15f3275f0e4.jpg";